import React from 'react';
import edit from '@nsgscholarship/assets/icons/edit.svg';
import { $t } from '@/modules/i18n';

export default () => {
  return (
    <div className="apply-now-container">
      <a href="https://docs.google.com/forms/d/e/1FAIpQLSeeE0T0q9ZQyf5uwWyBhpaTBgMVfXSLC5A1j0w9QmKgZ-ZceQ/viewform?usp=sf_link" target="_blank" className="apply-btn">
        <img src={edit} className="edit-icon"/>
        <div>{$t('nsgs_common_apply_now')}</div>
      </a>
    </div>
  )
}